import { CountryCode, parsePhoneNumber } from 'libphonenumber-js/min'

export function checkPhone(value: string, countryKey: string) {
  const minNationalNumbLength = 6
  const maxNationalNumbLength = 15

  if (countryKey.toUpperCase() === 'AQ') {
    // handle Antarctica numbers
    const number = value.substring(5)
    return number.length >= minNationalNumbLength && number.length < maxNationalNumbLength
  }
  try {
    const phoneNumber = parsePhoneNumber(value, countryKey.toUpperCase() as CountryCode | undefined)
    const nationalNumberPath = phoneNumber.nationalNumber.toString()
    return (
      phoneNumber.isValid() &&
      nationalNumberPath.length >= minNationalNumbLength &&
      nationalNumberPath.length < maxNationalNumbLength
    )
  } catch (e) {
    return false
  }
}
